// Canonical helpers for person-form fields used across all forms.
// Field order (everywhere a person is captured):
//   1. Gender, 2. First Name, 3. Surname, 4. DoB, 5. Email,
//   6. Phone (with country dial-code), 7. Address,
//   complementary: Postal code, City, Country (synced with phone country).

// Backend / DB value for the "Not Communicated" gender uses an underscore.
export const GENDER_NOT_COMMUNICATED = 'Not_Communicated';

// Build the canonical gender options list. Pass a `t` function (react-i18next).
// Tries multiple translation keys so we work in any form's namespace; falls back
// to English defaults so callers never see a blank label.
export const getGenderOptions = (t) => ([
    {
        value: 'male',
        label: t('common.gender.male', { defaultValue: t('doctorRegister.male', { defaultValue: 'Male' }) }),
    },
    {
        value: 'female',
        label: t('common.gender.female', { defaultValue: t('doctorRegister.female', { defaultValue: 'Female' }) }),
    },
    {
        value: GENDER_NOT_COMMUNICATED,
        label: t('common.gender.notCommunicated', { defaultValue: 'Not Communicated' }),
    },
    {
        value: 'other',
        label: t('common.gender.other', { defaultValue: t('doctorRegister.other', { defaultValue: 'Other' }) }),
    },
]);

// First Name: only the first character uppercased; the rest as-typed.
export const formatFirstName = (value) => {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
};

// Surname (family name): all characters uppercased.
export const formatSurname = (value) => {
    if (!value) return value;
    return value.toUpperCase();
};
